export const SHOW_SPINNER = 'SHOW_SPINNER';
